<template>
  <div>
    <div class="section-headers">How to get started</div>
    <div class="course-section">
      <div class="course-title">Brief Overview of Architect Features</div>
      <iframe height="400" width="200" src="https://www.youtube.com/embed/CJNO25kuwTE" frameborder="0" allow="autoplay; encrypted-media" ></iframe>
    </div>
    <div class="course-section">
      <div class="course-title"> How to Build a Habit Program within Architect</div>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/alZsClj2gJc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="course-section">
      <div class="course-title">Invite Clients to Start using Architect</div>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/wkAWW1dfVAI" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="course-section">
      <div class="course-title">How to Create a Cohort in Architect</div>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/UGzYDSk1fUc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="course-section">
      <div class="course-title">How to Build a Course in Architect</div>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/pjJt_4LwWeA" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="course-section">
      <div class="course-title">Client Onboarding Experience</div>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/sw8-H9Pm51w" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <modal v-if="display" @close="display=false" />
  </div>
</template>

<script>
import modal from "./modal";
export default {
  components: {
    modal
  },
  data() {
    return {
      display: this.$route.query.welcome === "true"
    };
  }
};
</script>

<style lang="less" scoped>
@media (min-width: 600px) {
  iframe {
    height: 315px;
    width: 560px;
  }
}
</style>
